import React from 'react';
import BodyCell, { IBodyCellProps } from './BodyCell';

const BodyCellPure = (props: IBodyCellProps) => (
  <BodyCell { ...props } />
);

export default React.memo(BodyCellPure);
